<template>
  <div id="questions">
    <headNav>
      <div slot="headNavText">{{$t('message.info_cjwt')}}</div>
    </headNav>
    <div class="container">
      <div>
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item :title="$t('message.info_cjwt_ybzx')" name="1">
            <ul class="list-without-buttons visible">
              <!---->
              <li class="ng-star-inserted">
                <div class="question">
                  <b class="a_q_bold">Q:</b>
                  <span _ngcontent-c17="">{{$t('message.info_cjwt_Q1')}}</span></div>
                <div class="answer-container">
                  <div class="answer">
                    <b class="a_q_bold">A:</b>
                    <span _ngcontent-c17="">{{$t('message.info_cjwt_a1')}}</span></div>
                </div>
              </li>
              <li class="ng-star-inserted">
                <div class="question">
                  <b class="a_q_bold">Q:</b>
                  <span _ngcontent-c17="">{{$t('message.info_cjwt_Q2')}}</span></div>
                <div class="answer-container">
                  <div class="answer">
                    <b class="a_q_bold">A:</b>
                    <span _ngcontent-c17="">{{$t('message.info_cjwt_a2')}}</span></div>
                </div>
              </li>
              <li class="ng-star-inserted">
                <div class="question">
                  <b class="a_q_bold">Q:</b>
                  <span _ngcontent-c17="">{{$t('message.info_cjwt_Q3')}}</span></div>
                <div class="answer-container">
                  <div class="answer">
                    <b class="a_q_bold">A:</b>
                    <span _ngcontent-c17="">{{$t('message.info_cjwt_a3')}}</span></div>
                </div>
              </li>
              <li class="ng-star-inserted">
                <div class="question">
                  <b class="a_q_bold">Q:</b>
                  <span _ngcontent-c17="">{{$t('message.info_cjwt_Q4')}}</span></div>
                <div class="answer-container">
                  <div class="answer">
                    <b class="a_q_bold">A:</b>
                    <span _ngcontent-c17="">{{$t('message.info_cjwt_a4')}}</span></div>
                </div>
              </li>
            </ul>
          </van-collapse-item>
          <van-collapse-item :title="$t('message.info_cjwt_hddk')" name="2">
            <ul class="list-without-buttons visible">
              <!---->
              <li class="ng-star-inserted">
                <div class="question">
                  <b class="a_q_bold">Q:</b>
                  <span _ngcontent-c17="">{{$t('message.info_cjwt_hddk_Q1')}}</span></div>
                <div class="answer-container">
                  <div class="answer">
                    <b class="a_q_bold">A:</b>
                    <span _ngcontent-c17="">{{$t('message.info_cjwt_hddk_a1')}}{{contact_tel}}{{$t('message.info_lxwm')}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </van-collapse-item>
          <van-collapse-item :title="$t('message.info_cjwt_dkzf')" name="3">
            <ul class="list-without-buttons visible">
              <!---->
              <li class="ng-star-inserted">
                <div class="question">
                  <b class="a_q_bold">Q:</b>
                  <span _ngcontent-c17="">{{$t('message.info_cjwt_dkzf_Q1')}}</span></div>
                <div class="answer-container">
                  <div class="answer">
                    <b class="a_q_bold">A:</b>
                    <span _ngcontent-c17="">{{$t('message.info_cjwt_dkzf_a1')}}</span>
                  </div>
                </div>
              </li>
              <li class="ng-star-inserted">
                <div class="question">
                  <b class="a_q_bold">Q:</b>
                  <span _ngcontent-c17="">{{$t('message.info_cjwt_dkzf_Q2')}}</span></div>
                <div class="answer-container">
                  <div class="answer">
                    <b class="a_q_bold">A:</b>
                    <span _ngcontent-c17="">{{$t('message.info_cjwt_dkzf_a2')}}</span></div>
                </div>
              </li>
            </ul>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
  </div>
</template>

<script>
  import headNav from "../HeadNav/headNav";
  import {customer_tel} from '../../ports/port'
  export default {
    name: "problem",
    data() {
      return {
        activeName: '1',
        contact_tel: ''
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      customer_tel()
        .then(res => {
          if (res.data.code == 200) {
            this.contact_tel = res.data.data.contact_tel;
          }
        })
    },
    components: {
      headNav
    },
  }
</script>

<style scoped lang="scss">
  @media (min-width:1430px) {
    #questions {
      padding: 70px 30px;
      .container {

      }
    }
  }
  @media (max-width:1430px) {
    #questions {
      padding: 1.4rem 0.3rem;
      .container {
        h1 {
          font-size: 0.53rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/problem.vue